<div class="row" *ngIf="paymentLabel && endingIn && editLabel">
    <div class="col-12 payment-method">
        <div id="button-payment-method" class="d-flex justify-content-between" style="width: 100%; text-align: left;">
            <div class="d-flex flex-column w-75">
                <div class="gb-body1 heavy mb-2">
                    <p id="p-payment-method" class="mb-0">{{paymentLabel}}</p>
                </div>
                <div class="gb-body1 d-flex align-items-center" style="color: #B50000" *ngIf="paymentMethod?.expiryStatus; else defaultBlock">
                    <div class="medium-icon">
                        <span aria-hidden="true" class="icon-ui-caution"></span>
                        {{paymentMethod.expiryStatus?.message}}
                    </div>
                </div>
                <ng-template #defaultBlock>
                    <div class="gb-body1 d-flex align-items-center">
                        <div class="medium-icon">
                            @if(paymentMethod.paymentType === 'ACH') {
                                <svg class="icon-bank mr-2" width="40px" height="40px">
                                    <use id="svg-payment-type" alt="imgAltText" [attr.href]="'/content/dam/gmownercenter/global/resources/icons/symbol-defs.svg#icon-bank' | link"></use>
                                </svg>
                            }@else{
                                <svg class="icon-pay-visa mr-2" style="width:50px; height: 50px;">
                                    <use id="svg-payment-type" alt="Payment Method Icon"
                                        [attr.href]="getPaymentMethodImageLink()">
                                    </use>
                                </svg>
                                <span id="payment-name" class="mr-1 align-middle">{{paymentMethod.paymentType}}</span>
                            }
                        </div>
                        <span id="span-ending-in" class="icon-svg-text">{{endingIn}}</span>
                    </div>
                </ng-template>
            </div>
            <div class="gb-body1 heavy">
                <a
                    (click)="navigateToPaymentMethodPage(editLabel,trackingString('link', [parentPlanName, editLabel]), 'PaymentMethods')"
                    class="gb-icon-button mx-auto"
                    aria-label="Edit Payments"
                    (keyup.enter)="navigateToPaymentMethodPage(editLabel,trackingString('link', [parentPlanName, editLabel]),'PaymentMethods')"
                    tabindex="0">
                    {{editLabel}}
                </a>
            </div>
        </div>
    </div>
</div>
